import { Grid, Typography } from '@mui/material';
import { Autosuggest, ImageUploader, SwitchInput, TextInput } from 'components';

export default function InPersonEventForm({
	handleChange,
	inPersonEvent,
	memoryFile,
	handleDelete,
	handleUpload
}) {
	return (
		<Grid container spacing={1}>
			<Grid item xs={12}>
				<TextInput
					name="name"
					value={inPersonEvent.name}
					label="Event Name"
					fullWidth
					handleChange={handleChange}
				/>
			</Grid>
			<Grid item xs={12}>
				<TextInput
					name="short_description"
					label="Short Description"
					fullWidth
					handleChange={handleChange}
					value={inPersonEvent.short_description}
				/>
			</Grid>
			<Grid item xs={12}>
				<TextInput
					name="description"
					label="Description"
					fullWidth
					multiline
					rows={4}
					handleChange={handleChange}
					value={inPersonEvent.description}
				/>
			</Grid>
			<Grid item xs={6}>
				<Typography variant="body2" color="textSecondary">
					{'Require Code'}
				</Typography>
				<SwitchInput
					value={inPersonEvent.is_private}
					label=""
					name="is_private"
					placeholder=""
					handleChange={handleChange}
				/>
			</Grid>
			<Grid item xs={6}>
				{inPersonEvent.is_private && (
					<TextInput
						name="event_code"
						label="Event Code"
						fullWidth
						required
						handleChange={handleChange}
						value={inPersonEvent.event_code}
					/>
				)}
			</Grid>

			<Grid item xs={6}>
				<TextInput
					name="end_date"
					label="End Date"
					type="date"
					fullWidth
					required
					handleChange={handleChange}
					value={inPersonEvent.end_date}
				/>
			</Grid>
			<Grid item xs={6} />
			<Grid item xs={6} alignContent={'center'} mt={3}>
				<SwitchInput
					value={inPersonEvent.published}
					label="Published"
					name="published"
					placeholder="Published"
					handleChange={handleChange}
				/>
			</Grid>

			<Grid item xs={12}>
				<Typography variant="body2" color="textSecondary">
					{'Event Image'}
				</Typography>
				<ImageUploader
					handleUpload={(file) => handleUpload(file, 'image_url')}
					imageUrl={inPersonEvent.image_url || memoryFile?.image_url?.url}
					label="Upload event image"
					handleDelete={() => {
						handleDelete('video_url');
						handleChange({ target: { name: 'video_url', value: '' } });
					}}
				/>
			</Grid>
		</Grid>
	);
}
